<template>
    <div class="thoroughbred-export-certificate">
        <div class="certificate-header">
            <div class="certificate-header-logo">
                <img src="../../../assets/libHorseRacingLogo.png" alt="thoroughbred-logo" class="thoroughbred-logo-image" />
            </div>
            <div class="certificate-header-text">
                <div class="certificate-header-text-row">Libyan Thoroughbred Stud Book</div>
                <div class="certificate-header-text-row">Export Certificate</div>
            </div>
        </div>
        <div class="certificate-form">
            <div>
                <div class="certificate-box">
                    <div class="certificate-row">
                        <div class="certificate-label">Name <span class="font-bold ml-1">{{ data?.horseName }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Colour <span class="font-bold ml-1">{{ data?.colour }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Sex <span class="font-bold ml-1">{{ data?.horseSex }}</span></div>
                        <div class="certificate-label">Date of birth <span class="font-bold ml-1">{{ data?.dateOfBirth }}</span></div>
                    </div>
                </div>
                <div class="certificate-box">
                    <div class="certificate-row">
                        <div class="certificate-label">Sire <span class="font-bold ml-1">{{ data?.sireName }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Dam <span class="font-bold ml-1">{{ data?.damName }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Damsire <span class="font-bold ml-1">{{ data?.damSireName }}</span></div>
                    </div>
                </div>
            </div>
            <div>
                <div class="certificate-box">
                    <div class="certificate-row">
                        <div class="certificate-label">Certificate No. <span class="font-bold ml-1">{{ data?.currentRegistrationNumber }}</span></div>
                        <div class="certificate-label">UELN <span class="font-bold ml-1">{{ data?.ueln }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">First Exported <span class="font-bold ml-1">{{ data?.dateOfExport }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Stud Book Ref. <span class="font-bold ml-1">{{ data?.originalStudBookReference }}</span></div>
                    </div>
                </div>
                <div class="certificate-box">
                    <div class="certificate-row">
                        <div class="certificate-label">Microchip No. <span class="font-bold ml-1">{{ data?.transponderCode }}</span></div>
                    </div>
                </div>
            </div>
            <div>
                <div class="certificate-box">
                    <div class="certificate-row">
                        <div class="certificate-label">Breeder <span class="font-bold">{{ computedText(data?.breederName,data?.breederAddress,data?.breederCountry) }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Country of Origin <span class="font-bold ml-1">{{ data?.countryOfOrigin }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Breed <span class="font-bold ml-1">Thoroughbred</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Destination <span class="font-bold ml-1">{{ data?.countryOfExport }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Consignee <span class="font-bold ml-1">{{ data?.newOwner }}</span></div>
                    </div>
                    <div class="certificate-row">
                        <div class="certificate-label">Contact Details</div>
                    </div>
                </div>
                <div class="certificate-box">
                    <div class="certificate-subbox">
                        <div class="certificate-label flex flex-column">Date of Issue <span class="font-bold ml-1">{{ todayDate() }}</span></div>
                    </div>
                    <div class="certificate-subbox">
                        <div class="certificate-label flex flex-column">Issuing Country <span class="font-bold ml-1">Libya</span></div>
                    </div>
                </div>
            </div>
            <div class="certificate-info-text">
                The issuer of this certificate wishes to make it clear that whilst it has no reason to doubt the accuracy of the information shown on this certificate, it accepts no responsibility for any errors or omissions
            </div>
            <div class="certificate-table-header">EXPORT CERTIFICATE ENDORSEMENTS</div>
            <DataTable class="certificate-table" showGridlines :value="tableValueOne">
                <Column header="Date & Journey" field="col1">
                    <template #body>
                        <div class="box-in-box"></div>
                    </template>
                </Column>
                <Column header="Consignee & Contact Details" field="col2"></Column>
                <Column header="Country Authorising Endorsement & Date of Endorsement" field="col3"></Column>
            </DataTable>
            <div class="break-after"></div>
            <div class="certificate-table-header">EXPORT CERTIFICATE ENDORSEMENTS CONTINUED</div>
            <DataTable class="certificate-table certificate-table__second" showGridlines :value="tableValueTwo">
                <Column header="Date & Journey" field="col1">
                    <template #body>
                        <div class="box-in-box"></div>
                    </template>
                </Column>
                <Column header="Consignee & Contact Details" field="col2"></Column>
                <Column header="Country Authorising Endorsement & Date of Endorsement" field="col3"></Column>
            </DataTable>
        </div>
    </div>

</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    name: "ExportThoroughbred",
    components: {
        DataTable,
        Column,
    },
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {
            tableValue: [
                {
                    col1: null,
                    col2: null,
                    col3: null,
                },
            ],
            tableValueOne: [],
            tableValueTwo: [],
        };
    },
    beforeMount() {
        for (let i = 0; i < 5; i += 1) {
            this.tableValueOne = this.tableValueOne.concat(this.tableValue);
        }
        for (let i = 0; i < 12; i += 1) {
            this.tableValueTwo = this.tableValueTwo.concat(this.tableValue);
        }
    },
    methods: {
        computedText(part1, part2, part3) {
            const text = [];

            if (part1) text.push(part1);
            if (part2) text.push(part2);
            if (part3) text.push(part3);

            return text.join("; ");
        },
        todayDate() {
            const today = new Date();

            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const year = today.getFullYear();

            return `${day}-${month}-${year}`;
        },
    },
};
</script>

<style lang="scss">
    .thoroughbred-export-certificate {
        page: export-document;
        .certificate-header {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-bottom: 1rem;
            &-logo {
                .thoroughbred-logo-image {
                    height: 100px;
                    width: 200px;
                }
            }
            &-text {
                text-align: center;
                &-row {
                    font-size: 1rem;
                    font-weight: bold;
                    font-family: var(--decor-font-family);
                }
            }
        }
        .certificate-form {
            font-size: .7rem;
            // font-weight: bold;
            display: flex;
            flex-direction: column;
            gap: 2px;
            div {
                gap: 2px;
                &:nth-of-type(1) {
                    display: flex;
                    .certificate-box {
                        border: 1px solid black;
                        padding: 2px;
                        &:nth-of-type(1) {
                            width: 50%;
                            display: flex;
                            flex-direction: column;
                            .certificate-row {
                                &:nth-of-type(3) {
                                    display: flex;
                                    .certificate-label {
                                        width: 50%;
                                    }
                                }
                            }
                        }
                        &:nth-of-type(2) {
                            width: 50%;
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
                &:nth-of-type(2) {
                    display: flex;
                    .certificate-box {
                        border: 1px solid black;
                        padding: 2px;
                        &:nth-of-type(1) {
                            width: 60%;
                            display: flex;
                            flex-direction: column;
                            .certificate-row {
                                &:nth-of-type(1) {
                                    display: flex;
                                    .certificate-label {
                                        width: 50%;
                                    }
                                }
                            }
                        }
                        &:nth-of-type(2) {
                            width: 40%;
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
                &:nth-of-type(3) {
                    display: flex;
                    .certificate-box {
                        &:nth-of-type(1) {
                            width: 75%;
                            display: flex;
                            flex-direction: column;
                            border: 1px solid black;
                            padding: 2px;
                        }
                        &:nth-of-type(2) {
                            width: 25%;
                            display: flex;
                            flex-direction: column;
                            gap: 0 !important;
                            .certificate-subbox {
                                text-align: center;
                                border: 1px solid black;
                                padding: 2px;
                                height: 3rem;
                                .certificate-label {
                                    display: block;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
            .certificate-info-text {
                font-weight: normal;
                font-family: var(--decor-font-family);
                font-size: .9rem;
            }
            .certificate-table-header {
                font-size: 1.5rem;
                text-align: center;
                font-weight: 500;
                font-family: var(--decor-font-family);
            }
            .certificate-table {
                font-size: .7rem;
                &.p-datatable {
                    border: 1px solid black;
                    .p-datatable-thead tr th {
                        font-weight: normal;
                        text-align: center;
                        border: 1px solid black;
                        &:nth-of-type(1) {
                            width: 26%;
                        }
                        &:nth-of-type(2) {
                            width: 37%;
                        }
                        &:nth-of-type(3) {
                            width: 37%;
                        }
                    }
                    .p-datatable-tbody tr {
                        height: 5rem;
                        td {
                            border: 1px solid black;
                            padding: 0;
                            position: relative;
                            .box-in-box {
                                position: absolute;
                                height: 3.5rem;
                                width: 100%;
                                border-top: 1px solid black;
                                bottom: 0;
                            }
                        }
                    }
                }
                &__second {
                    &.p-datatable {
                        .p-datatable-tbody tr {
                            height: 4.5rem;
                            td {
                                .box-in-box {
                                    height: 3rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
